import { IThunkContext } from '../types/redux';
import {
  fetchWebDeleteFavorites,
  IWebDeleteFavoritesRequest,
  TWebDeleteFavoritesResponse,
} from '../repositories/favorites/v1/web-delete-favorites';

export const deleteAllFavorites = (context: IThunkContext, parameters: IWebDeleteFavoritesRequest) => {
  const { httpApi, logger } = context;

  return fetchWebDeleteFavorites({ httpApi, parameters })
    .then((response: TWebDeleteFavoritesResponse) => {
      if (response.statusCode !== 200) {
        return null;
      }

      const { statusCode } = response;

      return {
        statusCode,
      };
    })
    .catch(error => {
      logger.error(error, {
        domain: 'fetchDesktopGetUserFavorites',
        details: {
          repository: 'frontend-favorites',
          service: 'favorites',
        },
      });

      throw new Error(error);
    });
};
